<div class="ai-req">
  <p class="ai-req__title"><i class="pi pi-exclamation-circle"></i> A few details are needed to finish:</p>

  <div class="ai-req__loading" *ngIf="loading"><i class="pi pi-spin pi-spinner"></i> Loading options…</div>

  <ng-container *ngIf="!loading">
    <div class="ai-req__field" *ngFor="let field of fields">
      <label class="ai-req__label">{{ label(field) }}</label>

      <ng-select
        *ngIf="isDropdown(field); else freeText"
        class="ai-req__select"
        [items]="options[field]"
        bindLabel="label"
        bindValue="value"
        [searchable]="true"
        [clearable]="false"
        [placeholder]="'Select ' + (label(field) | lowercase) + '…'"
        [disabled]="submitted"
        [(ngModel)]="selected[field]"></ng-select>

      <ng-template #freeText>
        <input
          class="ai-req__input"
          type="text"
          [(ngModel)]="selected[field]"
          [disabled]="submitted"
          [placeholder]="'Enter ' + (label(field) | lowercase)" />
      </ng-template>
    </div>

    <button type="button" class="ai-req__submit" [disabled]="!canSubmit" (click)="submit()">
      <i class="pi" [ngClass]="submitted ? 'pi-check' : 'pi-send'"></i>
      <span>{{ submitted ? 'Sent' : 'Create lead' }}</span>
    </button>
  </ng-container>
</div>
